import { render, staticRenderFns } from "./CreateNewOrder.vue?vue&type=template&id=0f196d59"
import script from "./CreateNewOrder.vue?vue&type=script&lang=js"
export * from "./CreateNewOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports